module.exports = __webpack_public_path__ + "img/gb9115_12.prt.a8c41145.jpg";